<ng-container>
    <cmps-wait-status
        *ngIf="hasPendingData === true"
        class="p-2"
    ></cmps-wait-status>
    <div
        class="text-center p-3"
        *ngIf="failLoad"
    >
        {{ failLoad }}
    </div>
    <table
        *ngIf="hasPendingData === false && data"
        class="commitments-tab-sec"
    >
        <thead>
            <tr>
                <th
                    (click)="sortByField(0)"
                    class="limit-width"
                >
                    <div>{{ i18n._7334_BEHAVIOUR | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[0].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    (click)="sortByField(1)"
                    class="limit-width"
                >
                    <div>{{ i18n._7364_SUB_BEHAVIOUR | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[1].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(2)">
                    <div>{{ i18n._7308_COACH | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[2].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(3)">
                    <div>{{ i18n._7309_SESSION_TYPE | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[3].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(4)">
                    <div>{{ i18n._7310_SESSION_DATE | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[4].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(5)">
                    <div>{{ i18n._127_STATUS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[5].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    (click)="sortByField(6)"
                    class="limit-width"
                >
                    <div>{{ i18n._7311_AGING | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[6].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    (click)="sortByField(7)"
                    class="limit-width"
                >
                    <div>
                        {{ i18n._7312_COMMITMENT_START_DATE | translate }}
                    </div>
                    <cmps-icon
                        [svgIcon]="sortFields[7].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(8)">
                    <div>{{ i18n._7313_LAST_UPDATE | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[8].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(9)">
                    <div>{{ i18n._7314___OF_OBSERVATIONS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[9].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(10)">
                    <div>{{ i18n._7315___OF_EVALUATIONS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[10].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(11)">
                    <div>{{ i18n._7316_CONSISTENCY | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[11].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th (click)="sortByField(12)">
                    <div>{{ i18n._7317_PROFICIENCY | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[12].direction | sortArrow"
                    ></cmps-icon>
                </th>
                <th
                    *ngIf="!displayGoals"
                    (click)="sortByField(13)"
                >
                    <div>{{ i18n._7318___OF_GOALS | translate }}</div>
                    <cmps-icon
                        [svgIcon]="sortFields[13].direction | sortArrow"
                    ></cmps-icon>
                </th>

                <ng-container *ngIf="displayGoals">
                    <th class="commitment-history-metricname">
                        {{ i18n._713_METRIC | translate }}
                        <div
                            class="cmps-cdk-cursor-pointer legacy:cmps-cdk-bg-color-green-100 cmps-cdk-border-radius-3px cmps-cdk-p-0dot25"
                            [title]="i18n._7319_HIDE_GOALS | translate"
                            tabindex="-1"
                            role="button"
                            (click)="hideSubs()"
                        >
                            <cmps-icon
                                class="cmps-cdk-fill-white"
                                svgIcon="arrow-collapse"
                            ></cmps-icon>
                        </div>
                    </th>
                    <th>{{ i18n._7320_GOAL_STATUS | translate }}</th>
                    <th>{{ i18n._7321_GOAL_CREATED_ON | translate }}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngFor="let c of displayData | slice: 0 : displayRecords"
            >
                <tr [hidden]="!c.display">
                    <td [rowSpan]="c.rowSpan">
                        <a (click)="iframe('Commitment', c.coachingEventId)">
                            {{ c.behaviour }}
                        </a>
                    </td>
                    <td [rowSpan]="c.rowSpan">
                        <a (click)="iframe('Commitment', c.coachingEventId)">
                            {{ c.subBehaviour }}
                        </a>
                    </td>
                    <td [rowSpan]="c.rowSpan">{{ c.coachName }}</td>
                    <td [rowSpan]="c.rowSpan">{{ c.sessionTypeName }}</td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.sessionDate | date: 'MM/dd/y' }}
                    </td>
                    <td [rowSpan]="c.rowSpan">{{ c.statusName }}</td>
                    <td [rowSpan]="c.rowSpan">{{ c.aging }}</td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.startDate | date: 'MM/dd/y' }}
                    </td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.lastUpdated | date: 'MM/dd/y' }}
                    </td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.observationCount || '-' }}
                    </td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.evaluationCount || '-' }}
                    </td>
                    <td [rowSpan]="c.rowSpan">{{ c.consistency || '-' }}</td>
                    <td [rowSpan]="c.rowSpan">
                        {{ c.proficiency | number: '1.1' }}
                    </td>
                    <td *ngIf="!displayGoals">
                        <a
                            (click)="showSubs()"
                            title="{{ i18n._7322_SHOW_GOALS | translate }}"
                            >{{ c.goalCount || '-' }}</a
                        >
                    </td>
                    <ng-container *ngIf="displayGoals">
                        <ng-container *ngIf="c.goals; else noG">
                            <td>{{ c.goals[0].metricName }}</td>
                            <td>{{ c.goals[0].goalStatusName }}</td>
                            <td>
                                {{ c.goals[0].createdOn | date: 'MM/dd/y' }}
                            </td>
                        </ng-container>
                        <ng-template #noG>
                            <td></td>
                            <td>-</td>
                            <td></td>
                        </ng-template>
                    </ng-container>
                </tr>
                <ng-container *ngIf="displayGoals">
                    <ng-container *ngIf="c.goals && c.goals.length > 1">
                        <tr *ngFor="let g of c.goals | slice: 1">
                            <td>{{ g.metricName }}</td>
                            <td>{{ g.goalStatusName }}</td>
                            <td>{{ g.createdOn | date: 'MM/dd/y' }}</td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="allRecordsHidden || !data || !data.length">
                <tr>
                    <td [colSpan]="displayGoals ? 14 : 16">
                        {{ i18n._7323_NO_RESULTS_ | translate }}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</ng-container>
